export enum ReportListItemStatus {
  CREATED = 'CREATED',
  EDITED = 'EDITED',
  SENT = 'SENT',
  READY_FOR_VALIDATION = 'READY_FOR_VALIDATION',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  VALIDATION_SUCCEEDED = 'VALIDATION_SUCCEEDED',
  SUBMITTED_VALIDATION_FALSE = 'SUBMITTED_VALIDATION_FALSE',
  SUBMITTED_VALIDATION_TRUE = 'SUBMITTED_VALIDATION_TRUE',
}
